import { render, staticRenderFns } from "./SystemMessagesWidget.vue?vue&type=template&id=ab2977a0&scoped=true&"
import script from "./SystemMessagesWidget.vue?vue&type=script&lang=js&"
export * from "./SystemMessagesWidget.vue?vue&type=script&lang=js&"
import style0 from "./SystemMessagesWidget.vue?vue&type=style&index=0&id=ab2977a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2977a0",
  null
  
)

export default component.exports